import { render, staticRenderFns } from "./row-detail.vue?vue&type=template&id=a4d3e28e&scoped=true&"
import script from "./row-detail.vue?vue&type=script&lang=js&"
export * from "./row-detail.vue?vue&type=script&lang=js&"
import style0 from "./row-detail.vue?vue&type=style&index=0&id=a4d3e28e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d3e28e",
  null
  
)

export default component.exports